import { createAction } from 'typesafe-actions';

import { MyStationsActions } from '../constants/MyStations';

type SetMyStationsDisplayParams = $TSFixMe;

interface SetMyStationsDisplayPayload {
  newDisplayType: SetMyStationsDisplayParams;
}

export const setMyStationsDisplayType = createAction(
  MyStationsActions.SET_MY_STATIONS_DISPLAY,
  (newDisplayType: SetMyStationsDisplayParams) => ({ newDisplayType }),
)<SetMyStationsDisplayPayload>();
export type SetMyStationsDisplayAction = ReturnType<typeof setMyStationsDisplayType>;

interface SetMyStationsDisplaySettingsPayload {
  newDisplayType: $TSFixMe;
  sortType: $TSFixMe;
  isDesc: boolean | $TSFixMe;
}

export const setMyStationsDisplaySettings = createAction(
  MyStationsActions.SET_MY_STATIONS_DISPLAY_SETTINGS,
  (newDisplayType: $TSFixMe, sortType: $TSFixMe, isDesc = false) => ({
    newDisplayType,
    sortType,
    isDesc,
  }),
)<SetMyStationsDisplaySettingsPayload>();
export type SetMyStationsDisplaySettingsAction = ReturnType<typeof setMyStationsDisplaySettings>;

interface SetMyStationsListSortPayload {
  sortType: $TSFixMe;
  isDesc: $TSFixMe;
}

export const setMyStationsListSort = createAction(
  MyStationsActions.SET_MY_STATIONS_LIST_SORT,
  (sortType: $TSFixMe, isDesc: $TSFixMe) => ({ sortType, isDesc }),
)<SetMyStationsListSortPayload>();
export type SetMyStationsListSortAction = ReturnType<typeof setMyStationsListSort>;

interface UpdateMyStationsListVisibleFieldsPayload {
  fieldToUpdate: $TSFixMe;
  newValue: $TSFixMe;
}

export const updateMyStationsListVisibleFields = createAction(
  MyStationsActions.UPDATE_MY_STATIONS_LIST_VISIBLE_FIELDS,
  (fieldToUpdate: $TSFixMe, newValue: $TSFixMe) => ({ fieldToUpdate, newValue }),
)<UpdateMyStationsListVisibleFieldsPayload>();
export type UpdateMyStationsListVisibleFieldsAction = ReturnType<
  typeof updateMyStationsListVisibleFields
>;
